var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.71 6.818a.468.468 0 0 0-.47.465v2.9c0 3.07-2.534 5.566-5.65 5.566-3.114 0-5.648-2.496-5.648-5.565V7.282a.468.468 0 0 0-.47-.464.468.468 0 0 0-.472.464v2.902c0 3.425 2.705 6.238 6.12 6.477v2.41H3.682a.468.468 0 0 0-.47.465c0 .256.21.464.47.464H9.5c.26 0 .472-.208.472-.464a.468.468 0 0 0-.472-.465H7.062v-2.41c3.415-.239 6.12-3.053 6.12-6.477V7.282a.468.468 0 0 0-.471-.464z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M6.668 0h-.609C3.971 0 2.273 1.723 2.273 3.842v6.407c0 2.119 1.698 3.842 3.786 3.842h.609c2.088 0 3.787-1.723 3.787-3.842V3.842C10.455 1.723 8.755 0 6.668 0zm2.873 5.044H7.886a.46.46 0 0 0-.457.464.46.46 0 0 0 .457.463H9.54v1.29H7.886a.46.46 0 0 0-.457.463.46.46 0 0 0 .457.463H9.54v1.29H7.886a.46.46 0 0 0-.457.464.46.46 0 0 0 .457.463h1.651c-.08 1.536-1.336 2.76-2.869 2.76h-.609c-1.533 0-2.79-1.224-2.869-2.76h1.652a.46.46 0 0 0 .457-.463.46.46 0 0 0-.457-.464H3.186v-1.29h1.656a.46.46 0 0 0 .457-.463.46.46 0 0 0-.457-.463H3.186V5.97h1.656a.46.46 0 0 0 .457-.463.46.46 0 0 0-.457-.464H3.186V3.842c0-1.156.666-2.156 1.629-2.627v1.31a.46.46 0 0 0 .456.463.46.46 0 0 0 .457-.463V.947a21.116 21.116 0 0 1 1.271 0v1.578a.46.46 0 0 0 .457.463.46.46 0 0 0 .457-.463v-1.31A2.922 2.922 0 0 1 9.54 3.84v1.203z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicrophone);
export default __webpack_public_path__ + "static/media/icon_microphone.c0436395fea0d88e2cb214631b7097b4.svg";
export { ForwardRef as ReactComponent };